export default "__VITE_ASSET__W350CXaA__"